export default {
  title: 'Dominio del negozio',
  description:
    'Pubblica i negozi online dei tuoi ristoranti su un dominio tuo invece che sull’indirizzo condiviso, ad esempio pizza-mario.ordini-tuomarchio.it. Aggiungi due record DNS una sola volta; ogni ristorante che aggiungi in seguito riceve automaticamente il suo indirizzo.',
  read_only_description:
    'Il dominio su cui sono pubblicati i negozi dei ristoranti di questo partner. Solo il partner può collegarlo o modificarlo.',
  read_only_empty: 'Questo partner non ha collegato alcun dominio del negozio.',
  not_connected: {
    label: 'Dominio per i negozi dei tuoi ristoranti',
    hint: 'Un dominio o sottodominio di tua proprietà, ad esempio ordini-tuomarchio.it. Deve essere un dominio diverso da quello su cui funzionano le app del tuo team, non un suo sottodominio.',
    placeholder: 'ordini-tuomarchio.it',
    connect: 'Collega',
  },
  status: {
    pending_dns: 'In attesa del DNS',
    active: 'Attivo',
    failed: 'Azione richiesta',
    disabled: 'Scollegato',
  },
  primary_badge: 'Principale',
  summary: {
    pending: 'Stiamo aspettando i tuoi record DNS. Di solito bastano pochi minuti, a volte qualche ora.',
    failed:
      'Non siamo riusciti a confermare tutti i record in tempo. Correggi il record segnalato qui sotto, poi premi Controlla di nuovo: da lì ricominciamo a controllare.',
    failed_leave: 'Per collegare invece un dominio diverso, prima scollega questo.',
    live: '{{host}} è attivo.',
    primary: 'Ogni nuovo ristorante riceve automaticamente il suo indirizzo su questo dominio.',
    standby:
      'Rendilo principale perché ogni nuovo ristorante lo riceva automaticamente. I ristoranti già su un altro dominio restano dove sono.',
    regressed:
      '{{host}} è attivo, ma un record qui sotto non viene più confermato. I tuoi negozi sono ancora online: correggi il record presso il tuo provider DNS.',
  },
  instructions: {
    title: 'Come aggiungere i record',
    step_provider:
      'Accedi dove viene gestito il DNS di {{root}}: di solito il provider da cui hai acquistato il dominio.',
    step_add: 'Aggiungi ogni record qui sotto esattamente come mostrato: tipo, nome e valore.',
    step_check: 'Salva, poi fai clic su «{{button}}». Continuiamo anche a controllare per conto nostro.',
    tip_name:
      'La maggior parte dei provider vuole nel campo del nome solo la parte prima di {{root}}: _foodamigos-verify e *. Il nome completo è mostrato qui sotto, per i provider che lo richiedono.',
    tip_wildcard:
      'Il record * indirizza ogni indirizzo sotto {{root}} ai tuoi negozi, così non devi mai aggiungere un record per ristorante.',
    tip_existing:
      'I record già esistenti per {{root}}, ad esempio quelli del tuo sito, della posta o di www, continuano a funzionare: il record * risponde solo ai nomi che non hanno un record proprio. Se {{root}} ha già un record *, sostituiscilo con il nostro.',
    tip_cloudflare:
      'Su Cloudflare, imposta il record CNAME su «Solo DNS» (nuvola grigia), altrimenti non possiamo vederlo.',
  },
  records: {
    title: 'Aggiungi questi record DNS per {{root}} presso il tuo provider di dominio',
  },
  example: 'Un ristorante sarà quindi a un indirizzo come {{host}}.',
  example_label: 'tuo-ristorante',
  buttons: {
    check_again: 'Controlla di nuovo',
    make_primary: 'Rendi principale',
    unlink: 'Scollega',
    retry: 'Riprova',
  },
  primary_unavailable: 'Disponibile quando il dominio è attivo.',
  unlink_blocked_one:
    '{{count}} ristorante è ancora su questo dominio. Spostalo su un altro dominio prima di scollegarlo.',
  unlink_blocked_other:
    '{{count}} ristoranti sono ancora su questo dominio. Spostali su un altro dominio prima di scollegarlo.',
  unlink_confirm: {
    title: 'Scollegare {{host}}?',
    description: 'Potrai ricollegare {{host}} in seguito.',
    description_primary:
      'I nuovi ristoranti ricevono di nuovo un indirizzo sul dominio condiviso. Potrai ricollegare {{host}} in seguito.',
    ok: 'Scollega',
  },
  toasts: {
    load_error: 'Impossibile caricare il tuo dominio del negozio',
    load_error_read_only: 'Impossibile caricare il dominio del negozio di questo partner',
    connected: 'Dominio collegato: ora aggiungi i record qui sotto',
    connect_failed: 'Impossibile collegare il dominio',
    check_started: 'Nuovo controllo in corso…',
    check_failed: 'Impossibile avviare il controllo. Riprova tra un minuto.',
    primary_set: 'I nuovi ristoranti ricevono ora questo dominio',
    primary_failed: 'Impossibile rendere principale questo dominio',
    unlinked: 'Dominio scollegato',
    unlink_failed: 'Impossibile scollegare il dominio',
    unlink_has_restaurants_one:
      '{{count}} ristorante è ancora su {{host}}: {{names}}. Spostalo su un altro dominio prima di scollegarlo.',
    unlink_has_restaurants_other:
      '{{count}} ristoranti sono ancora su {{host}}: {{names}}. Spostali su un altro dominio prima di scollegarlo.',
    gone: '{{host}} non è più collegato: forse è stato scollegato in un’altra scheda.',
  },
};
